/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. The table is generated entirely in your browser; nothing is uploaded.`)
};

const es_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La tabla se genera completamente en tu navegador; nada se carga.`)
};

const de_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Die Tabelle wird vollständig in Ihrem Browser erstellt; es wird nichts hochgeladen.`)
};

const nl_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. De tabel wordt volledig in uw browser gegenereerd; er wordt niets geüpload.`)
};

const fr_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Le tableau est généré entièrement dans votre navigateur ; rien n'est téléchargé.`)
};

const it_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. La tabella è generata interamente nel vostro browser; nulla viene caricato.`)
};

const pt_br2_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A tabela é gerada inteiramente no seu navegador; nada é carregado.`)
};

const pt_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. A tabela é gerada inteiramente no seu navegador; nada é carregado.`)
};

const ja_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。テーブルはブラウザで完全に生成され、何もアップロードされません。`)
};

const zh_mt_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。表格完全在你的浏览器中生成，不会上传任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mt_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mt_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mt_faq3_a", locale)
	if (locale === "en") return en_mt_faq3_a(inputs)
	if (locale === "es") return es_mt_faq3_a(inputs)
	if (locale === "de") return de_mt_faq3_a(inputs)
	if (locale === "nl") return nl_mt_faq3_a(inputs)
	if (locale === "fr") return fr_mt_faq3_a(inputs)
	if (locale === "it") return it_mt_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_mt_faq3_a(inputs)
	if (locale === "pt") return pt_mt_faq3_a(inputs)
	if (locale === "ja") return ja_mt_faq3_a(inputs)
	return zh_mt_faq3_a(inputs)
};